<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">{{'TRANSFER.TRANSFER' | translate}}</div>
        <div class="col-12 text-center modal-subtitle mb-4">{{'TRANSFER.SELECT_USER' | translate}}</div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="col-12">
            <label class="form-label" for="candidateId">
                {{'TRANSFER.RECIPIENT' | translate}}
            </label>
            <div class="row">
                <div class="col-12">
                    <select class="form-select" aria-label="Select candidate" [(ngModel)]="candidateId" id="candidateId">
                        <option *ngFor="let candidate of candidates" [value]="candidate.id">{{candidate.email}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center my-3">
        <div class="col-12">
            <label class="form-label" for="comment">
                {{'ACTIONS.ADD_COMMENT' | translate}}
            </label>
            <textarea name="message" [(ngModel)]="comment" id="comment" class="col-12 form-content bg-transparent border" rows="5" placeholder="Add a comment here..."></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action error cancel-btn" (click)="closeModal()">{{'CANCEL' | translate}}</button>
        </div>
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action primary withdraw-btn" (click)="confirmTransfer()">{{'TRANSFER.TRANSFER' | translate}}</button>
        </div>
    </div>
</div>